import userFuncs from "./user";
import waitlistFuncs from "./waitlist";
import emailFuncs from "./emailNotifications";
import textFuncs from "./textNotifications";

export default {
  removeFromWaitlist: waitlistFuncs.removeFromWaitlist,
  createUser: userFuncs.createUser,
  addUserToDB: userFuncs.addUserToDB,
  addUserDataDocs: userFuncs.addUserDataDocs,

  sendPlayerContactEmail: emailFuncs.sendPlayerContactEmail,
  sendAcceptedEmail: emailFuncs.sendAcceptedEmail,
  sendDeclinedEmail: emailFuncs.sendDeclinedEmail,
  sendConfirmationNeededEmail: emailFuncs.sendConfirmationNeededEmail,
  sendConfirmationAcceptedEmail: emailFuncs.sendConfirmationAcceptedEmail,
  sendConfirmationDeclinedEmail: emailFuncs.sendConfirmationDeclinedEmail,
  sendRequestReceivedEmail: emailFuncs.sendRequestReceivedEmail,
  sendPlayerConfirmedEmail: emailFuncs.sendPlayerConfirmedEmail,
  sendPlayerDeclinedEmail: emailFuncs.sendPlayerDeclinedEmail,

  sendConfirmationNeededText: textFuncs.sendConfirmationNeededText,
  sendPlayerConfirmedText: textFuncs.sendPlayerConfirmedText,
};
